export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Chyba inicializace",
    "StaticConfigLoader.caption.init": "Inicializace",
    "StaticConfigLoader.text.init": "Inicializace aplikace...",
    "StaticConfigLoader.error.settings": "Nebylo možné načíst nastavení stránky",
    "StaticConfigLoader.error.circuits": "Nebylo možné načíst nastavení služeb",
    //app
    "Legal.Localization": "cs",
    "AchievementApp.Navbar.storeTitle": "Obchod",
    "AchievementApp.Navbar.supportTitle": "Podpora",
    "Legal.TermsConditions": "Smluvní podmínky",
    "Legal.TermsService": "Podmínky používání služby",
    "Legal.PrivacyPolicy": "Zásady ochrany osobních údajů",
    "Legal.CookiesPolicy": "Nastavení souborů cookie",
    "Legal.Copyright": "Všechny ochranné známky, loga a názvy značek jsou majetkem příslušných vlastníků.",
    "AchievementApp.Navbar.achievement": "Osobní úspěch",
    "AchievementApp.Navbar.userAchievement": "Uživatelský úspěch",
    "AchievementApp.Navbar.settingsLink": "Nastavení",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Přihlaste se znovu nebo změňte účet",
    "AchievementApp.Navbar.pageTitlePrew": "Úspěchy ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Dokončeno",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtrovat podle názvů",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Moji přátelé",
    "UserFriendsList.heading.showMore": "Zobrazit více",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Musíte nakonfigurovat dvoufázové ověření",
    "LimitedAccountPanel.2step.link": "Další informace o dvoufázovém ověření",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Musíte potvrdit e-mailovou adresu",
    "LimitedAccountPanel.email.link": "Přejít k profilu",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Váš účet je omezen kvůli:",
    "LimitedAccountPanel.conclusion": "Po změně bezpečnostních nastavení byste se měli odhlásit a přihlásit, aby se změny projevily",
    "LimitedAccountPanel.relogin": "Opětovné přihlášení",
    "EmailVerificationStateIcon.success": "Potvrzený účet, ověřený e-mail",
    "EmailVerificationStateIcon.warning": "Nepotvrzený účet, neověřený e-mail",
    "EmailVerificationStateIcon.danger": "Nepotvrzený účet, je NUTNÉ ověřit e-mail",
    "TwoFactorStateIcon.success": "Účet je zabezpečen dvoufázovým ověřením",
    "TwoFactorStateIcon.warning": "Nezabezpečený účet, dvoufázové ověření vypnuto",
    "TwoFactorStateIcon.danger": "Je VYŽADOVÁNO dvoufázové ověření",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Uložit nastavení",
    "UserSettingDialog.settings": "Nastavení",
    "UserSettingDialog.userSettings": "Uživatelská nastavení",
    "UserSettingDialog.language": "Jazyk",
    "UserSettingDialog.privacy": "Soukromí",
    "UserSettingDialog.allUsers": "Všichni uživatelé",
    "UserSettingDialog.friendsOnly": "Pouze přátelé",
    "UserSettingDialog.onlyMe": "Pouze já",
    "UserSettingDialog.whoCanView": "Kdo může zobrazit mé úspěchy",
    //unlockProgress
    "ViewUnlockProgress.of": " z ",
    "ViewUnlockProgress.achievCompleted": " dosažených úspěchů",
    "ViewUnlockProgress.myUnlock": "Moje úspěchy",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Najít přezdívku",
    "ViewItemSearch.label.search": "Vyhledat uživatele",
    "ViewItemSearch.resultNotFound": "Uživatel nebyl nalezen",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Úspěch",
    "ViewItemSearch.stub.empty": "Žádné úspěchy",
    "ViewItemSearch.stub.emptyCompare_1": "Uživatel ",
    "ViewItemSearch.stub.emptyCompare_2": " nemá v této hře žádné dosažené úspěchy",
    "ViewItemSearch.limitedAccess": "Přístup k úspěchům vybraného uživatele je omezen",
    "ViewItemSearch.heading.selectGame": "Vyberte hru ze seznamu",
    "ViewItemSearch.globalstat.opened": "odemčeno ",
    "ViewItemSearch.globalstat.ofGamers": "% hráčů",
    //authentication
    "NotAllowedMessage.caption": "Není povoleno",
    "NotAllowedMessage.body.h1": "Přístup k úspěchu",
    "NotAllowedMessage.body.h3": "není v tuto chvíli u vašeho účtu povolen",
    "NotAllowedMessage.relogin": "Změnit účet",
    "LandingMessage.caption": "Ověřování",
    "LandingMessage.body": "Nahrávání se dokončuje...",
    "TokenExpiredMessage.caption": "Ověření vypršelo",
    "TokenExpiredMessage.body.h3": "S tímto vám moc nepomůžeme, ale stále ještě můžete zkusit následující",
    "TokenExpiredMessage.relogin": "Opětovné přihlášení",
    "AuthErrorMessage.caption": "Ověření selhalo",
    "AuthErrorMessage.body.h1": "Nepovedlo se zkontrolovat ověření",
    "AuthErrorMessage.body.code": "Kód",
    "AuthErrorMessage.body.desc": "S tímto vám moc nepomůžeme, ale stále ještě můžete zkusit následující",
    "AuthErrorMessage.relogin": "Opětovné přihlášení",
    "AuthorizationRequiredMessage.caption": "Je vyžadováno ověření",
    "AuthorizationRequiredMessage.body.h3.1": "Chystáte se vstoupit",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "K dalšímu postupu musíte mít oprávnění",
    "AuthorizationRequiredMessage.login": "Přihlásit se pomocí Gaijin.Net",
    "CheckingAuthMessage.caption": "Ověřování",
    "CheckingAuthMessage.body": "Kontrola ověření, chvíli strpení prosím",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Mobilní verze je dočasně nedostupná",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Použijte verzi pro počítače",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Omlouváme se",
}